import type { ButtonHTMLAttributes, ReactNode } from "react";
import Link from "next/link";

const VARIANTS = {
  primary:
    "bg-accent text-white hover:bg-accent-deep focus-visible:outline-accent disabled:opacity-50",
  secondary:
    "border border-hairline-strong bg-surface text-ink hover:border-accent hover:text-accent-deep focus-visible:outline-accent disabled:opacity-50",
  danger:
    "border border-danger/40 bg-surface text-danger hover:bg-danger-wash focus-visible:outline-danger disabled:opacity-50",
  ghost:
    "text-muted hover:text-ink focus-visible:outline-accent disabled:opacity-50",
} as const;

export type ButtonVariant = keyof typeof VARIANTS;

const BASE =
  "inline-flex items-center justify-center gap-1.5 rounded-md px-3.5 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2";

export function Button({
  variant = "primary",
  className = "",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant }) {
  return <button className={`${BASE} ${VARIANTS[variant]} ${className}`} {...rest} />;
}

export function LinkButton({
  href,
  variant = "secondary",
  className = "",
  children,
  ...rest
}: {
  href: string;
  variant?: ButtonVariant;
  className?: string;
  children: ReactNode;
} & Record<string, unknown>) {
  return (
    <Link href={href} className={`${BASE} ${VARIANTS[variant]} ${className}`} {...rest}>
      {children}
    </Link>
  );
}
